import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import axiosInstance from '../../utils/axiosSetup';
import usePermissionChecker from '../../action/checkPermission';


const Sidebar = () => {
    const { checkPermission } = usePermissionChecker();
    const user = JSON.parse(localStorage.getItem('userInfo'));

    const [leavecount, setLeaveCount] = useState("");
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [GetViewMore, setViewMore] = useState(true);

    const location = useLocation();

    const fetchLeaves = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/leaves/create`)
            .then(response => {
                setLeaveCount(response.data.data.count);
            })
            .catch(error => {
                console.error('Error', error);
                setLeaveCount("");
            });
    }

    useEffect(() => {
        fetchLeaves();
    }, []);

    const handleDropdownToggle = (dropdownName) => {
        setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
    };

    const isActive = (path) => location.pathname === path ? 'active' : '';

    const viewmoremenu = () => setViewMore(prev => !prev);
    
    return (
        <div className="sidebar" id="sidebar">
            <div className="sidebar-inner slimscroll" style={{overflowY:'auto'}}>
                <div id="sidebar-menu" className="sidebar-menu">
                    <nav className="greedys sidebar-horizantal">
                        <ul className="list-inline-item list-unstyled links">
                            <li className={isActive('/dashboard')}>
                                <Link to="/dashboard"><i className="la la-dashcube"></i> <span>Dashboard</span></Link>
                            </li>
                            <li className="menu-title">
                                <span>Master</span>
                            </li>
                            <li className="submenu">
                                <Link to="#" onClick={() => handleDropdownToggle('apps')} className={activeDropdown === 'apps' ? 'active subdrop' : ''}>
                                    <i className="la la-gear"></i> <span> Settings</span> 
                                    <span className="menu-arrow"></span>
                                </Link>
                                <ul style={{ display: activeDropdown === 'apps' ? 'block' : 'none' }}>                                    
                                    {(checkPermission("Roles")) && (
                                        <li><Link to="/roles" className={isActive('/roles')}>Roles</Link></li>
                                    )}
                                    {(checkPermission("Permissions")) && (
                                        <li><Link to="/permissions" className={isActive('/permissions')}>Permissions</Link></li>
                                    )}
                                    {(checkPermission("Role Permission")) && (
                                        <li><Link to="/role-permission" className={isActive('/role-permission')}>Role Permission</Link></li>
                                    )}
                                    {(checkPermission("Departments")) && (
                                        <li><Link to="/departments" className={isActive('/departments')}>Departments</Link></li>
                                    )}
                                    {(checkPermission("Task Types")) && (
                                        <li><Link to="/task-types" className={isActive('/task-types')}>Task Types</Link></li>
                                    )}
                                    {(checkPermission("Leaves Credebility")) && (
                                        <li><Link to="/leaves-credebility" className={isActive('/leaves-credebility')}>Leaves Credebility</Link></li>
                                    )}
                                    <li><Link to="/calendar" className={isActive('/calendar')}>Calendar</Link></li>
                                    <li><Link to="/holidays" className={isActive('/holidays')}>Holiday</Link></li>
                                    {user.role_name === 'Super-Admin' ? (
                                        <li><Link to="/announcements" className={isActive('/announcements')}>Announcements</Link></li>
                                    ) : (
                                        <li><Link to="/all-announcements" className={isActive('/announcements')}>Announcements</Link></li>
                                    )}
                                </ul>
                            </li>

                            {checkPermission("Basic Projects") && (
                                <li className="submenu">
                                    <Link to="#" onClick={() => handleDropdownToggle('basicProjects')} className={activeDropdown === 'basicProjects' ? 'active subdrop' : ''}>
                                        <i className="lab la-uikit"></i> <span> Basic Projects</span> 
                                        <span className="menu-arrow"></span>
                                    </Link>
                                    <ul style={{ display: activeDropdown === 'basicProjects' ? 'block' : 'none' }}>
                                        <li><Link to="/basic-projects" className={isActive('/basic-projects')}>Basic Projects</Link></li>
                                    </ul>
                                </li>
                            )}

                            {checkPermission("Channel") && (
                                <li className="submenu">
                                    <Link to="#" onClick={() => handleDropdownToggle('channel')} className={activeDropdown === 'channel' ? 'active subdrop' : ''}>
                                        <i className="la la-laptop-medical"></i> <span> Channel</span> 
                                        <span className="menu-arrow"></span>
                                    </Link>
                                    <ul style={{ display: activeDropdown === 'channel' ? 'block' : 'none' }}>
                                        <li><Link to="/channels" className={isActive('/channels')}>Current Channel List</Link></li>
                                        <li><Link to="/inactive-channels" className={isActive('/inactive-channels')}>Past Channel List</Link></li>
                                    </ul>
                                </li>
                            )}

                            {checkPermission("Client") && (
                                <li className="submenu">
                                    <Link to="#" onClick={() => handleDropdownToggle('client')} className={activeDropdown === 'client' ? 'active subdrop' : ''}>
                                        <i className="la la-users"></i> <span> Client</span> 
                                        <span className="menu-arrow"></span>
                                    </Link>
                                    <ul style={{ display: activeDropdown === 'client' ? 'block' : 'none' }}>
                                        <li><Link to="/clients" className={isActive('/clients')}>Current Client List</Link></li>
                                        <li><Link to="/inactive-clients" className={isActive('/inactive-clients')}>Past Client List</Link></li>
                                    </ul>
                                </li>
                            )}

                            {checkPermission("Meter") && (
                                <li className="submenu">
                                    <Link to="#" onClick={() => handleDropdownToggle('meter')} className={activeDropdown === 'meter' ? 'active subdrop' : ''}>
                                        <i className="la la-icons"></i> <span> Meter</span> 
                                        <span className="menu-arrow"></span>
                                    </Link>
                                    <ul style={{ display: activeDropdown === 'meter' ? 'block' : 'none' }}>
                                        <li><Link to="/meter" className={isActive('/meter')}>Active Meter</Link></li>
                                        <li><Link to="/inactive-meter" className={isActive('/inactive-meter')}>Inactive Meter</Link></li>
                                    </ul>
                                </li>
                            )}

                            {checkPermission("Projects") && (
                                <li className="submenu">
                                    <Link to="#" onClick={() => handleDropdownToggle('project')} className={activeDropdown === 'project' ? 'active subdrop' : ''}>
                                        <i className="la la-rocket"></i> <span> Projects</span> 
                                        <span className="menu-arrow"></span>
                                    </Link>
                                    <ul style={{display: activeDropdown === 'project' ? 'block' : 'none' }}>
                                        <li><Link to="/projects" className={isActive('/projects')}>Create Project</Link></li>
                                        <li><Link to="/on-hold-projects" className={isActive('/on-hold-projects')}>On Hold Project</Link></li>
                                        <li><Link to="/completed-projects" className={isActive('/completed-projects')}>Completed Project</Link></li>
                                        <li><Link to="/inactive-projects" className={isActive('/inactive-projects')}>In-Active Project</Link></li>
                                    </ul>
                                </li>
                            )}
                        </ul>
                        <button className="viewmoremenu" onClick={viewmoremenu}>More Menu</button>
                        <ul className={`hidden-links ${GetViewMore ? 'hidden' : ''}`}>
                            {checkPermission("Project Meter") && (
                                <li className="submenu">
                                    <Link to="#" onClick={() => handleDropdownToggle('projectMeter')} className={activeDropdown === 'projectMeter' ? 'active subdrop' : ''}>
                                        <i className="la la-exchange-alt"></i> <span> Project Meter</span> 
                                        <span className="menu-arrow"></span>
                                    </Link>
                                    <ul style={{ display: activeDropdown === 'projectMeter' ? 'block' : 'none' }}>
                                        <li><Link to="/project-meter" className={isActive('/project-meter')}>Active Project Meter</Link></li>
                                        <li><Link to="/inactive-project-meter" className={isActive('/inactive-project-meter')}>Inactive Project Meter</Link></li>
                                    </ul>
                                </li>
                            )}

                            {checkPermission("Assign Project") && (
                                <li className="submenu">
                                    <Link to="#" onClick={() => handleDropdownToggle('assignProject')} className={activeDropdown === 'assignProject' ? 'active subdrop' : ''}>
                                        <i className="la la-directions"></i> <span> Assign Project</span> 
                                        <span className="menu-arrow"></span>
                                    </Link>
                                    <ul style={{ display: activeDropdown === 'assignProject' ? 'block' : 'none' }}>
                                        <li><Link to="/assign-project" className={isActive('/assign-project')}>Assign Project</Link></li>
                                    </ul>
                                </li>
                            )}

                            <li className="menu-title">
                                <span>Employees</span>
                            </li>
                            <li className="submenu">
                                <Link to="#" onClick={() => handleDropdownToggle('employees')} className={activeDropdown === 'employees' ? 'active subdrop' : ''}>
                                    <i className="la la-user"></i> <span> Employees</span>
                                    <span className="menu-arrow"></span>
                                </Link>
                                <ul style={{ display: activeDropdown === 'employees' ? 'block' : 'none' }}>
                                    {checkPermission("Employees") && (
                                        <>
                                            <li><Link to="/employees" className={isActive('/employees')}>Active Employees</Link></li>
                                            <li><Link to="/inactive-employees" className={isActive('/inactive-employees')} >Inactive Employees</Link></li>
                                        </>
                                    )}
                                    <li><Link to="/leaves" className={isActive('/leaves')}>Leaves 
                                            {leavecount !== 0 ? <span className="badge rounded-pill bg-primary float-end">{leavecount}</span> : "" }
                                        </Link>
                                    </li>
                                </ul>
                            </li>

                            <li className="submenu">
                                <Link to="#" onClick={() => handleDropdownToggle('timelog')} className={activeDropdown === 'timelog' ? 'active subdrop' : ''}>
                                    <i className="la la-history"></i> <span> Time Log</span>
                                    <span className="menu-arrow"></span>
                                </Link>
                                <ul style={{ display: activeDropdown === 'timelog' ? 'block' : 'none' }}>
                                    {user.role_name !== 'Super-Admin' && (
                                        <>
                                            <li><Link to="/assigned-projects" className={isActive('/assigned-projects')}> Assigned Projects </Link></li>
                                            <li><Link to="/timelog" className={isActive('/timelog')}> TimeLog </Link></li>
                                        </>
                                    )}
                                    {checkPermission("Morning Time Logs") && (
                                        <li><Link to="/timelog/manageTimeMorning" className={isActive('/timelog/manageTimeMorning')}>Manage Time Morning</Link></li>
                                    )}
                                    {checkPermission("Evening Time Logs") && (
                                        <li><Link to="/timelog/manageTimeEvening" className={isActive('/timelog/manageTimeEvening')}> Manage Time Evening</Link></li>
                                    )}
                                </ul>
                            </li>

                            {(checkPermission("QA")) && (
                                <li className={isActive('/qa')}>
                                    <Link to="/qa"><i className="la la-question-circle"></i> <span>QA</span></Link>
                                </li>
                            )}

                            {(checkPermission("Daily Reports")) && (
                                <li className="submenu">
                                    <Link to="#" onClick={() => handleDropdownToggle('reports')} className={activeDropdown === 'reports' ? 'active subdrop' : ''}>
                                        <i className="la la-file-alt"></i> <span> Daily Reports</span>
                                        <span className="menu-arrow"></span>
                                    </Link>
                                    <ul style={{ display: activeDropdown === 'reports' ? 'block' : 'none' }}>
                                        <li><Link to="/em-not-filled" className={isActive('/em-not-filled')}>EM Not Filled</Link></li>
                                        <li><Link to="/tl-approval-pending" className={isActive('/tl-approval-pending')}>TL Approval Pending</Link></li>
                                    </ul>
                                </li>
                            )}

                            {(checkPermission("Project Reports")) && (
                                <li className="submenu">
                                    <Link to="#" onClick={() => handleDropdownToggle('p-reports')} className={activeDropdown === 'p-reports' ? 'active subdrop' : ''}>
                                        <i className="la la-file-alt"></i> <span> Project Reports</span>
                                        <span className="menu-arrow"></span>
                                    </Link>
                                    <ul style={{ display: activeDropdown === 'p-reports' ? 'block' : 'none' }}>
                                        <li><Link to="/project-reports" className={isActive('/project-reports')}>Project Reports</Link></li>
                                        <li><Link to="/client-wise-reports" className={isActive('/client-wise-reports')}>Client-Wise Reports</Link></li>
                                    </ul>
                                </li>
                            )}
                        </ul>
                    </nav>

                    <ul className="sidebar-vertical">
                        <li className={isActive('/dashboard')}>
                            <Link to="/dashboard"><i className="la la-dashcube"></i><span>Dashboard</span></Link>
                        </li>
                        <li className="menu-title">
                            <span>Master</span>
                        </li>
                        <li className="submenu">
                            <Link to="#" onClick={() => handleDropdownToggle('apps')} className={activeDropdown === 'apps' ? 'active subdrop' : ''}>
                                <i className="la la-gear"></i> <span> Settings</span> 
                                <span className="menu-arrow"></span>
                            </Link>
                            <ul style={{ display: activeDropdown === 'apps' ? 'block' : 'none' }}>
                                {(checkPermission("Roles")) && (
                                    <li><Link to="/roles" className={isActive('/roles')}>Roles</Link></li>
                                )}
                                {(checkPermission("Permissions")) && (
                                    <li><Link to="/permissions" className={isActive('/permissions')}>Permissions</Link></li>
                                )}
                                {(checkPermission("Role Permission")) && (
                                    <li><Link to="/role-permission" className={isActive('/role-permission')}>Role Permission</Link></li>
                                )}
                                {(checkPermission("Departments")) && (
                                    <li><Link to="/departments" className={isActive('/departments')}>Departments</Link></li>
                                )}
                                {(checkPermission("Task Types")) && (
                                    <li><Link to="/task-types" className={isActive('/task-types')}>Task Types</Link></li>
                                )}
                                {(checkPermission("Leaves Credebility")) && (
                                    <li><Link to="/leaves-credebility" className={isActive('/leaves-credebility')}>Leaves Credebility</Link></li>
                                )}
                                <li><Link to="/calendar" className={isActive('/calendar')}>Calendar</Link></li>
                                <li><Link to="/holidays" className={isActive('/holidays')}>Holiday</Link></li>
                                {user.role_name === 'Super-Admin' ? (
                                    <li><Link to="/announcements" className={isActive('/announcements')}>Announcements</Link></li>
                                ) : (
                                    <li><Link to="/all-announcements" className={isActive('/announcements')}>Announcements</Link></li>
                                )}
                            </ul>
                        </li>

                        {(checkPermission("Basic Projects")) && (
                            <li className="submenu">
                                <Link to="#" onClick={() => handleDropdownToggle('basicProjects')} className={activeDropdown === 'basicProjects' ? 'active subdrop' : ''}>
                                    <i className="lab la-uikit"></i> <span> Basic Projects</span> 
                                    <span className="menu-arrow"></span>
                                </Link>
                                <ul style={{ display: activeDropdown === 'basicProjects' ? 'block' : 'none' }}>
                                    <li><Link to="/basic-projects" className={isActive('/basic-projects')}>Basic Projects</Link></li>
                                </ul>
                            </li>
                        )}

                        {(checkPermission("Channel")) && (
                            <li className="submenu">
                                <Link to="#" onClick={() => handleDropdownToggle('channel')} className={activeDropdown === 'channel' ? 'active subdrop' : ''}>
                                    <i className="la la-laptop-medical"></i> <span> Channel</span> 
                                    <span className="menu-arrow"></span>
                                </Link>
                                <ul style={{ display: activeDropdown === 'channel' ? 'block' : 'none' }}>
                                    <li><Link to="/channels" className={isActive('/channels')}>Current Channel List</Link></li>
                                    <li><Link to="/inactive-channels" className={isActive('/inactive-channels')}>Past Channel List</Link></li>
                                </ul>
                            </li>
                        )}

                        {(checkPermission("Client")) && (
                            <li className="submenu">
                                <Link to="#" onClick={() => handleDropdownToggle('client')} className={activeDropdown === 'client' ? 'active subdrop' : ''}>
                                    <i className="la la-users"></i> <span> Client</span> 
                                    <span className="menu-arrow"></span>
                                </Link>
                                <ul style={{ display: activeDropdown === 'client' ? 'block' : 'none' }}>
                                    <li><Link to="/clients" className={isActive('/clients')}>Current Client List</Link></li>
                                    <li><Link to="/inactive-clients" className={isActive('/inactive-clients')}>Past Client List</Link></li>
                                </ul>
                            </li>
                        )}

                        {(checkPermission("Meter")) && (
                            <li className="submenu">
                                <Link to="#" onClick={() => handleDropdownToggle('meter')} className={activeDropdown === 'meter' ? 'active subdrop' : ''}>
                                    <i className="la la-icons"></i> <span> Meter</span> 
                                    <span className="menu-arrow"></span>
                                </Link>
                                <ul style={{ display: activeDropdown === 'meter' ? 'block' : 'none' }}>
                                    <li><Link to="/meter" className={isActive('/meter')}>Active Meter</Link></li>
                                    <li><Link to="/inactive-meter" className={isActive('/inactive-meter')}>Inactive Meter</Link></li>
                                </ul>
                            </li>
                        )}

                        {((checkPermission("Projects")) || (checkPermission("Project Meter")) || (checkPermission("Assign Project"))) && (
                            <li className="menu-title">
                                <span>Projects</span>
                            </li>
                        )}

                        {(checkPermission("Projects")) && (
                            <li className="submenu">
                                <Link to="#" onClick={() => handleDropdownToggle('project')} className={activeDropdown === 'project' ? 'active subdrop' : ''}>
                                    <i className="la la-rocket"></i> <span> Projects</span> 
                                    <span className="menu-arrow"></span>
                                </Link>
                                <ul style={{display: activeDropdown === 'project' ? 'block' : 'none' }}>
                                    <li><Link to="/projects" className={isActive('/projects')}>Create Project</Link></li>
                                    <li><Link to="/on-hold-projects" className={isActive('/on-hold-projects')}>On Hold Project</Link></li>
                                    <li><Link to="/completed-projects" className={isActive('/completed-projects')}>Completed Project</Link></li>
                                    <li><Link to="/inactive-projects" className={isActive('/inactive-projects')}>In-Active Project</Link></li>
                                </ul>
                            </li>
                        )}
                        
                        {(checkPermission("Project Meter")) && (
                            <li className="submenu">
                                <Link to="#" onClick={() => handleDropdownToggle('projectMeter')} className={activeDropdown === 'projectMeter' ? 'active subdrop' : ''}>
                                    <i className="la la-exchange-alt"></i> <span> Project Meter</span> 
                                    <span className="menu-arrow"></span>
                                </Link>
                                <ul style={{ display: activeDropdown === 'projectMeter' ? 'block' : 'none' }}>
                                    <li><Link to="/project-meter" className={isActive('/project-meter')}>Active Project Meter</Link></li>
                                    <li><Link to="/inactive-project-meter" className={isActive('/inactive-project-meter')}>Inactive Project Meter</Link></li>
                                </ul>
                            </li>
                        )}

                        {(checkPermission("Assign Project")) && (
                            <li className="submenu">
                                <Link to="#" onClick={() => handleDropdownToggle('assignProject')} className={activeDropdown === 'assignProject' ? 'active subdrop' : ''}>
                                    <i className="la la-directions"></i> <span> Assign Project</span> 
                                    <span className="menu-arrow"></span>
                                </Link>
                                <ul style={{ display: activeDropdown === 'assignProject' ? 'block' : 'none' }}>
                                    <li><Link to="/assign-project" className={isActive('/assign-project')}>Assign Project</Link></li>
                                </ul>
                            </li>
                        )}

                        <li className="menu-title">
                            <span>Employees</span>
                        </li>
                        {(checkPermission("Employees")) && (
                            <li className="submenu">
                                <Link to="#" onClick={() => handleDropdownToggle('employees')} 
                                    className={`${activeDropdown === 'employees' ? 'active subdrop' : ''}`}>
                                        <i className="la la-user"></i> <span> Employees</span>
                                        <span className="menu-arrow"></span>
                                </Link>
                                <ul style={{ display: activeDropdown === 'employees' ? 'block' : 'none' }}>
                                    <li><Link to="/employees" className={isActive('/employees')}>Active Employees</Link></li>
                                    <li><Link to="/inactive-employees" className={isActive('/inactive-employees')}>Inactive Employees</Link></li>
                                </ul>
                            </li>
                        )}

                        <li className="submenu">
                            <Link to="#" onClick={() => handleDropdownToggle('leaves')} 
                                className={`${activeDropdown === 'leaves' ? 'active subdrop' : ''} ${leavecount !== 0 ? 'noti-dot' : ''}`}>
                                    <i className="la la-edit"></i> <span> Leaves</span> 
                                    <span className="menu-arrow"></span></Link>
                            <ul style={{ display: activeDropdown === 'leaves' ? 'block' : 'none' }}>
                                <li>
                                    <Link to="/leaves" className={isActive('/leaves')}>Leaves 
                                        {leavecount !== 0 ? <span className="badge rounded-pill bg-primary float-end">{leavecount}</span> : "" }
                                    </Link>
                                </li>
                            </ul>
                        </li>

                        <li className="submenu">
                            <Link to="#" onClick={() => handleDropdownToggle('timelog')} className={activeDropdown === 'timelog' ? 'active subdrop' : ''}>
                                <i className="la la-history"></i> <span> Time Log</span> 
                                <span className="menu-arrow"></span>
                            </Link>
                            <ul style={{ display: activeDropdown === 'timelog' ? 'block' : 'none' }}>
                                {user.role_name !== 'Super-Admin' && (
                                    <>
                                        <li><Link to="/assigned-projects" className={isActive('/assigned-projects')}> Assigned Projects </Link></li>
                                        <li><Link to="/timelog" className={isActive('/timelog')}> TimeLog </Link></li>
                                    </>
                                )}
                                    
                                {(checkPermission("Morning Time Logs")) && (
                                    <li><Link to="/timelog/manageTimeMorning" className={isActive('/timelog/manageTimeMorning')}>Manage Time Morning</Link></li>
                                )}

                                {(checkPermission("Evening Time Logs")) && (
                                    <li><Link to="/timelog/manageTimeEvening" className={isActive('/timelog/manageTimeEvening')}> Manage Time Evening</Link></li>
                                )}
                            </ul>
                        </li>

                        {(checkPermission("QA")) && (
                            <>
                                <li className="menu-title">
                                    <span>Performance</span>
                                </li>
                                <li className={isActive('/qa')}>
                                    <Link to="/qa">
                                        <i className="la la-question-circle"></i> <span>QA</span>
                                    </Link>
                                </li>
                            </>
                        )}

                        {(checkPermission("Daily Reports") || checkPermission("Project Reports")) && (
                            <>
                                <li className="menu-title">
                                    <span>Reports</span>
                                </li>

                                {checkPermission("Daily Reports") && (
                                    <li className="submenu">
                                        <Link to="#" onClick={() => handleDropdownToggle('reports')} className={activeDropdown === 'reports' ? 'active subdrop' : ''}>
                                            <i className="la la-file-alt"></i> <span> Daily Reports</span>
                                            <span className="menu-arrow"></span>
                                        </Link>
                                        <ul style={{ display: activeDropdown === 'reports' ? 'block' : 'none' }}>
                                            <li><Link to="/em-not-filled" className={isActive('/em-not-filled')}>EM Not Filled</Link></li>
                                            <li><Link to="/tl-approval-pending" className={isActive('/tl-approval-pending')}>TL Approval Pending</Link></li>
                                        </ul>
                                    </li>
                                )}

                                {checkPermission("Project Reports") && (
                                    <li className="submenu">
                                        <Link to="#" onClick={() => handleDropdownToggle('p-reports')} className={activeDropdown === 'p-reports' ? 'active subdrop' : ''}>
                                            <i className="la la-file-alt"></i> <span> Project Reports</span>
                                            <span className="menu-arrow"></span>
                                        </Link>
                                        <ul style={{ display: activeDropdown === 'p-reports' ? 'block' : 'none' }}>
                                            <li><Link to="/project-reports" className={isActive('/project-reports')}>Project Reports</Link></li>
                                            <li><Link to="/client-wise-reports" className={isActive('/client-wise-reports')}>Client-Wise Reports</Link></li>
                                        </ul>
                                    </li>
                                )}
                            </>
                        )}
                    </ul>
                </div>
            </div>
        </div>
    );
}

export default Sidebar;
